import React from "react";
import "./mainpart.scss";
import Mission from "../../../assets/images/mission-card-image.svg";
import Vision from "../../../assets/images/vision-card-image.svg";
import { Fade } from "react-reveal";
export default function AboutMainPart() {
  const about_card = [
    {
      image: Mission,
      heading: "Our Mission",
      desc1:
        "Delivering next-generation software solutions that empower businesses and individuals to thrive in the digital age.",
      desc2:
        "Our mission is delivering quality with satisfactory application solutions. We strive to develop long-term partnerships with our clients based on transparency, trust, exceptional service, and much more. At Vedhas, we are dedicated to helping our clients stay ahead in the ever-evolving digital landscape and achieve success through technology.",
    },
    {
      image: Vision,
      heading: "Our Vision",
      desc1:
        "Our vision is to lead in software innovation, empowering organisations and individuals to achieve their full potential.",
      desc2:
        "We envision a future where every business has access to high-quality and fair software solutions that enable them to thrive in their respective domains. With a focus on collaboration, innovation, and brilliance, we strive to be the leading software development company that businesses turn to for all their technology needs.",
    },
  ];
  return (
    <section className="about_page">
      <div className="container">
        <div className="about-card-grid">
          {about_card &&
            about_card?.map((el, i) => {
              return (
                <div className="about-sub-card" title={el?.heading} key={i}>
                  <Fade bottom duration={500} delay={300}>
                    <img src={el?.image} alt="Mission" />
                  </Fade>
                  <Fade bottom duration={600} delay={400}>
                    <h2>{el?.heading}</h2>
                  </Fade>
                  <Fade bottom duration={700} delay={500}>
                    <p>{el?.desc1}</p>
                  </Fade>
                  <Fade bottom duration={800} delay={600}>
                    <p>{el?.desc2}</p>
                  </Fade>
                </div>
              );
            })}
        </div>
      </div>
    </section>
  );
}
